
<!--
  --
  -- 支払方法 概要 コンポーネント
  --
  -->
<template>
  <!-- カード情報 payment.cardNo payment.defaultFlg -->
  <v-row align="center">
    <!-- カード番号 -->
    <v-col>{{cardNumber}}</v-col>

    <!-- 有効期限 -->
    <v-col cols="auto" class="monospace font-weight-bold" :class="expireColor">
      {{payment.expire | timeformat('m / Y')}}
    </v-col>

    <!-- デフォルトフラグ -->
    <v-col cols="auto">
      <div class="mr-2">
        <v-icon v-if="payment.defaultFlg" small color="primary">star</v-icon>
        <div v-else class="w-4 h-4"/>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import * as time from '@/libs/time'

export default {
  name: 'CPaymentSummary',
  props: {
    payment: {
      type: Object,
      required: true
    }
  },
  computed: {
    /**
     * カード番号を表記
     *
     * モバイルのときは 末尾 xxx の表記にする
     */
    cardNumber () {
      if (!this.$vuetify.breakpoint.xsOnly) {
        return this.payment.cardNo
      }
      return '****' + this.payment.cardNo.replace(/\*/g, '')
    },

    /**
     * カードの有効期限のステータス
     */
    expireStatus () {
      const today = time.today()

      // 警告する日付: 1ヶ月前
      const warnDate = time.clone(today)
      warnDate.setMonth(warnDate.getMonth() + 1)

      // 期限切れとする日付: 今日
      const expiredDate = time.clone(today)

      // 日付文字列にする
      const warn = time.format('Y-m-d', warnDate)
      const expired = time.format('Y-m-d', expiredDate)

      if (this.payment.expire < expired) {
        return 'expired'
      } else if (this.payment.expire < warn) {
        return 'warn'
      }
      return 'ok'
    },

    /**
     * 有効期限の色
     */
    expireColor () {
      switch (this.expireStatus) {
        case 'warn': return 'warning--text'
        case 'expired': return 'error--text'
      }
      return ''
    }
  }
}
</script>
